<script setup lang="ts">
  import { useAuthStore } from '@/stores/auth';
  import { useEnvironmentsStore } from '@/stores/environments';

  const errorStatus = ref(null);
  const environmentsStore = useEnvironmentsStore();
  const authStore = useAuthStore();

  onBeforeMount(async () => {
    try {
      await environmentsStore.getEnvironments();
    } catch (error: any) {
      if (authStore.isAuthorized.value) {
        errorStatus.value = error.response?.status || error.status;
      }
    }
  });
</script>

<template>
  <VToast />
  <RouterView v-if="!errorStatus" />
  <VErrorLayout v-else :status="errorStatus" />
</template>
